// plugins/router-reload.client.js
import { defineNuxtPlugin } from '#app';
import { useRouter } from 'vue-router';

export default defineNuxtPlugin(() => {
  const router = useRouter();
  let isRedirecting = false;

  router.beforeEach((to, from, next) => {
    // If we're in the middle of a redirect, just proceed
    if (isRedirecting) {
      isRedirecting = false;
      return next();
    }

    // Check if only query params changed (same path)
    const isSamePathDifferentQuery =
      to.path === from.path &&
      JSON.stringify(to.query) !== JSON.stringify(from.query);

    // If query changed and we haven't added reloadKey yet, add it
    if (isSamePathDifferentQuery && !to.meta.reloadKey) {
      isRedirecting = true;
      return next({
        ...to,
        meta: { ...to.meta, reloadKey: Date.now() },
        replace: true, // Use replace to avoid history pollution
      });
    }

    // For all other cases, proceed normally
    next();
  });
});
